import prefetchImage from "./index.web";
export default prefetchImage;
